/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { Avatar, Stack } from "@mui/material";

export default function CustomerAvatar() {
  const { customer, isLoading } = useCustomer();

  if (!customer || isLoading) {
    return null;
  }

  return (
    <Stack direction={"row"}>
      <Avatar
        sx={(theme) => ({
          backgroundColor: theme.palette.primaryPale,
          width: 40,
          height: 40,
        })}
      >{`${customer.person.givenName?.[0] ?? ""}${customer.person.familyName?.[0] ?? ""}`}</Avatar>
    </Stack>
  );
}
